import { getAssetsUrl } from './constants';

const baseUrl = getAssetsUrl();

export const sliderImages = [
  {
    url: `${baseUrl}/images/20241116_162754_IMG_6277.DNG.jpg`,
    title: 'Peaceful Ganges River',
  },
  {
    url: `${baseUrl}/images/20241120_124626_IMG_6297.DNG.jpg`,
    title: 'Meditation & Yoga',
  },
  {
    url: `${baseUrl}/images/20241120_124759_IMG_6301.DNG.jpg`,
    title: 'Spiritual Journey',
  },
  {
    url: `${baseUrl}/images/20241120_125253_IMG_6306.DNG.jpg`,
    title: 'Lakshman Jhula Bridge',
  },
  {
    url: `${baseUrl}/images/20241120_125058_IMG_6304.DNG.jpg`,
    title: 'Yoga & Wellness',
  }
]; 